// src/components/LoadingSpinner.js
import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = () => (
  <motion.div
    className="flex justify-center items-center h-screen"
    animate={{ rotate: 360 }}
    transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
  >
    <div className="w-16 h-16 border-4 border-t-primary border-b-secondary border-l-accent border-r-transparent rounded-full"></div>
  </motion.div>
);

export default LoadingSpinner;